import ResultPage from '@/components/Result/index';
import { assetUrl } from '@/utils/asset-url';
import Toast from '@/components/Toast/index';
import { etrActionable } from '@/constants/etr/etr-action/index';
import useToast from '@/hooks/use-toast/index';
import { useLocation, Navigate } from '@/lib/router-dom/index';

const TransferSuccessPage = () => {
	const { currentState } = useLocation();
	const { toastList } = useToast()

	const type = currentState?.type;
	const etrMakerCheckerTransactionName = currentState?.etrMakerCheckerTransactionName;
	const transferableRecordId = currentState?.transferableRecordId;
	const makerChecker = currentState?.makerChecker;

	if (!currentState) {
		return <Navigate to="/" replace={true} />
	}

	let title = "";
	let layoutSubHeaderTxt = "";
	switch (type) {
		case etrActionable.endorseOwner:
			title = makerChecker
				? "Sent For Approval!"
				: "Nomination successful!";
			layoutSubHeaderTxt = makerChecker
				? "You can check the updated E-Transferable Record by clicking the “Done” button below or keep track of it's approval activity via “ETR List” section."
				: 'You can check the updated E-Transferrable Record by clicking the "Return" button.';
			break;
		case etrActionable.transferHolder:
			title = makerChecker ? 'Sent For Approval!' : 'Transfer Successful!';
			layoutSubHeaderTxt = makerChecker ?
				"You can check the updated E-Transferable Record by clicking the “Done” button below or keep track of it's approval activity via “ETR List” section." :
				'You can check the updated E-Transferrable Record by clicking the "Return" button.';
			break;
		case etrActionable.transferOwner:
			title = makerChecker ? 'Sent For Approval!' : 'Transfer Successful!';
			layoutSubHeaderTxt = makerChecker ?
				"You can check the updated E-Transferable Record by clicking the “Done” button below or keep track of it's approval activity via “ETR List” section." :
				'You can check the updated E-Transferrable Record by clicking the "Return" button.';
			break;
		case etrActionable.surrender:
			title = makerChecker
				? "Sent For Approval!"
				: "Document surrender successful!";
			layoutSubHeaderTxt = makerChecker
				? "You can check the updated E-Transferable Record by clicking the “Done” button below or keep track of it's approval activity via “ETR List” section."
				: 'You can check the updated E-Transferrable Record by clicking the "Return" button.';
			break;
		case etrActionable.transferOwnerAndHolder:
			title = makerChecker ? 'Sent For Approval!' : 'Transfer Successful!';
			layoutSubHeaderTxt = makerChecker ?
				"You can check the updated E-Transferable Record by clicking the “Done” button below or keep track of it's approval activity via “ETR List” section." :
				'You can check the updated E-Transferrable Record by clicking the "Return" button.';
			break;
		case etrActionable.rejectSurrender:
			title = 'Surrender Rejected.';
			layoutSubHeaderTxt = 'You can view the updated ETR on the ETR List Tab.';
			break;
		case etrActionable.acceptSurrender:
			title = 'Shredding in Progress.';
			layoutSubHeaderTxt = 'You can view the updated ETR on the ETR List Tab.';
			break;
		case etrActionable.rejectTransfer:
			title = makerChecker ? 'Sent For Approval!' : 'Rejection in Progress.';
			layoutSubHeaderTxt = makerChecker ?
				"You can check the updated E-Transferable Record by clicking the “Done” button below or keep track of it's approval activity via “ETR List” section." :
				'You can view the updated ETR on the ETR List Tab.';
			break;
		default:
	}

	const breadcrumbsItem = [
		{
			label: '',
			link: '/'
		 },
		{
			label: 'E-Transferable Record',
			link: '/record-transfer'
		},
		{
			label: etrMakerCheckerTransactionName,
			link:''
		}
	]



	return (
		<>
			{ResultPage({
				defaultTitle: "Transaction Success",
				layoutHeaderTxt: title,
				layoutSubHeaderTxt: layoutSubHeaderTxt,
				layoutContentImgPath: assetUrl("/img/theme-success.png"),
				backBtnTxt: 'Done',
				breadcrumbs: breadcrumbsItem,
				nextLocation: '/record-transfer',
				translationCheck: false,
				viewRecordLocation: `/record-transfer/record-details/${transferableRecordId}`,
				viewETRRecord: true
			})}
			<Toast toastList={toastList} />
		</>
	);
}

export default TransferSuccessPage
